import styled from 'styled-components';
import {Link } from 'react-router-dom';
import {theme } from '../../styles/theme';

export const FooterContainer = styled.footer`
  background-color: ${theme.colors.dark};
  color: ${theme.colors.white};
  padding: ${theme.spacing.lg} ${theme.spacing.md};
  margin-top: auto;
  font-family: 'Poppins', sans-serif;
`;

export const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: ${theme.spacing.xl};
  padding-bottom: ${theme.spacing.lg};

  @media (max-width: ${theme.breakpoints.md}) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

export const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};

  @media (max-width: ${theme.breakpoints.md}) {
    align-items: center;
  }
`;

export const FooterTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: ${theme.spacing.sm};
  color: ${theme.colors.primary};
`;

export const FooterLink = styled(Link)`
  color: ${theme.colors.light};
  text-decoration: none;
  font-size: 0.95rem;
  transition: color 0.2s, transform 0.2s;

  &:hover {
    color: ${theme.colors.white};
    transform: translateX(5px);
  }

  @media (max-width: ${theme.breakpoints.md}) {
    &:hover {
      transform: none;
    }
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: ${theme.spacing.md};
  margin-top: ${theme.spacing.sm};

  @media (max-width: ${theme.breakpoints.md}) {
    justify-content: center;
  }
`;

export const SocialIcon = styled.a`
  color: ${theme.colors.white};
  background-color: ${theme.colors.gray};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  transition: background-color 0.3s, color 0.3s, transform 0.3s;

  &:hover {
    background-color: ${theme.colors.primary};
    color: ${theme.colors.dark};
    transform: translateY(-3px);
  }
`;

export const Copyright = styled.div`
  text-align: center;
  margin-top: ${theme.spacing.lg};
  padding-top: ${theme.spacing.md};
  border-top: 1px solid ${theme.colors.gray};
  color: ${theme.colors.light};
  font-size: 0.9rem;
`;

export const NewsletterForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
  margin-top: ${theme.spacing.sm};

  @media (max-width: ${theme.breakpoints.md}) {
    align-items: center;
  }
`;

export const NewsletterInput = styled.input`
  padding: 10px 15px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.gray};
  background-color: ${theme.colors.background};
  color: ${theme.colors.text};
  font-size: 1rem;
  width: 100%;
  max-width: 300px;
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
  }
`;

export const SubscribeButton = styled.button`
  background-color: ${theme.colors.primary};
  color: ${theme.colors.dark};
  font-weight: 600;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  max-width: 300px;

  &:hover {
    background-color: ${theme.colors.primaryDark};
    transform: translateY(-2px);
  }
  
  &:active {
    transform: translateY(0);
  }
`;